// "Agora" como store externo (React Compiler: `Date.now()` é impuro durante a renderização). Atualiza a cada minuto
// enquanto houver assinantes — suficiente para "bloqueado até", expirações e afins.
import { useSyncExternalStore } from 'react';

export const NOW_REFRESH_MS = 60_000;

let cachedNow = Date.now();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | null = null;

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  timer ??= setInterval(() => {
    cachedNow = Date.now();
    for (const notify of listeners) {
      notify();
    }
  }, NOW_REFRESH_MS);
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== null) {
      clearInterval(timer);
      timer = null;
    }
  };
}

function getSnapshot(): number {
  return cachedNow;
}

/** Instante corrente (ms desde a época), estável dentro de uma renderização. */
export function useNow(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

/** `true` quando `iso` é um instante futuro em relação a `now`. */
export function isInFuture(iso: string | null | undefined, now: number): boolean {
  return typeof iso === 'string' && new Date(iso).getTime() > now;
}
